import { ForwardedRef } from 'react'
import { Observer, observer } from 'mobx-react-lite'
import cx from '@ui-components-3/ui/lib/utils/classNames'
import type { ChatMessage } from 'models/Provider/visits/PendingVisit/Chat'
import './style.css'

type MessagesProps = {
  msg: ChatMessage
  displayName: string
}

const VIEWED_AT_FORMATTER = new Intl.DateTimeFormat('us', {
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
})

const Message = ({ msg, displayName }: MessagesProps, ref: ForwardedRef<HTMLDivElement>) => (
  <div ref={ref} className="mb-m">
    <div
      className={cx(
        'relative p-xs rounded-lg typography-body',
        msg.my
          ? 'bg-neutral-500 text-white chat-message-triangle-my before:text-neutral-500'
          : 'bg-white text-primary-800 chat-message-triangle before:text-white border border-[#C2D8EC]',
      )}
    >
      {displayName}: <span className="whitespace-pre-line break-words">{msg.message}</span>
      <div className="text-right typography-small">{msg.createdTime}</div>
    </div>
    <Observer>
      {() =>
        msg.my && msg.rawViewedDate ? (
          <div className="text-right typography-small text-neutral-500">
            <span className="font-bold">Read</span> {VIEWED_AT_FORMATTER.format(msg.rawViewedDate).toLowerCase()}
          </div>
        ) : null
      }
    </Observer>
  </div>
)

export default observer(Message, { forwardRef: true })
